/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithLineItemRequestBuilder, WithLineItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/carts/{cart-id}/{shoppingCartId}/lines
 */
export interface LinesRequestBuilder extends BaseRequestBuilder<LinesRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.carts.item.item.lines.item collection
     * @param lineId Gets or sets the id of the line to change, as the cart reports it on every line.
     * @returns {WithLineItemRequestBuilder}
     */
     byLineId(lineId: string) : WithLineItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const LinesRequestBuilderUriTemplate = "{+baseurl}/api/carts/{cart%2Did}/{shoppingCartId}/lines";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const LinesRequestBuilderNavigationMetadata: Record<Exclude<keyof LinesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byLineId: {
        requestsMetadata: WithLineItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["lineId"],
    },
};
/* tslint:enable */
/* eslint-enable */
